import { IntegrationType } from '@assetaccountant/integrations/models/integration-type';

export interface AssetTransaction {
  // ID is returned but not useful for transactions, often 0
  id?: number;
  date: string;
  type: string;
  notes: string;
  cost?: number;
  created?: string;
  createdByUserFullName?: string;
  createdBySource?: IntegrationType;
  sourceId?: string;
  depreciation?: number;
  taxableDepreciation?: number;
  writtenDownValue?: number;
  externalReferenceNo?: string;

  // Transfer
  poolCode?: string;
  poolName?: string;
  transferredValue?: number;

  // Pool Disposal
  price?: number;

  // First Use / Reassessment
  methodCode?: string;
  life?: number;
  remainingUnits?: number;
  rate?: number;
  originalDate?: string;
  originalCost?: number;
  residualValue?: number;
  isSelfAssessed?: boolean;

  taxableUse?: number;

  // PoolAsset
  poolAssetId?: number;
  poolAssetName?: string;

  // FieldAssignment & FieldUpdate
  fieldName?: string;
  /**
   * @deprecated use toValues
   */
  toValue?: string;
  /**
   * @deprecated use fromValues
   */
  fromValue?: string;
  toValues?: Array<{ value: string; allocation: number }>;
  fromValues?: Array<{ value: string; allocation: number }>;

  // Revaluation
  revaluationReserve?: number;

  // Impairment
  unimpairedRate?: number;
  impairmentProvision?: number;
  importBySourceName?: string;

  // Components
  parentId?: number | null;
  parentCode?: string | null;
  parentName?: string | null;
  componentId?: number | null;
  componentCode?: string | null;
  componentName?: string | null;

  // Asset Groups
  assetGroupId?: number;
}

export const ALL_TYPES_BUT_REVERSALS = [
  'Purchase',
  'PurchaseCapLimit',
  'SetQuantity',
  'WriteBack',
  // Depreciation
  'FirstUse',
  'TaxableUse',
  'Reassessment',
  'OpeningBalance',
  'Depreciation',
  'DepreciationEstimated',
  'Immediate',
  'Usage',
  'AdditionalCost',
  // Disposals
  'Sale',
  'WriteOff',
  'QuantitySale',
  'QuantityWriteOff',
  // Asset in Pool
  'AddToPool',
  'TransferToPool',
  'PoolSale',
  'PoolWriteOff',
  'PoolQuantitySale',
  'PoolQuantityWriteOff',
  // Other
  'Revaluation',
  'Impairment',
  'Adjustment',
  'StartAdjustment',
  'EndAdjustment',
  // Pools
  'PoolOpeningBalance',
  'PoolAddition',
  'PoolAdditionBeforeOpeningBalance',
  'PoolTransfer',
  'PoolTransferBeforeOpeningBalance',
  'PoolAssetTaxableUse',
  'PoolAutomaticWriteOff',
  // Pools - Asset Disposals
  'PoolAssetSale',
  'PoolAssetWriteOff',
  'PoolAssetQuantitySale',
  'PoolAssetQuantityWriteOff',
  'PoolBalancingAdjustment',
  // Classifications
  'FieldValueAssignedToAsset',
  'FieldValueUpdatedForAsset',
  // Components
  'ComponentAdded',
  'ParentAdded',
  'ComponentRemoved',
  'ParentRemoved',
  'InterestAccrual',
  // Asset Groups
  'AssetGroupAssignedToAsset',
];
